export class PaginationRequestCommand {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = 'id';
  pageNumber: number = 1;
  pageSize: number = 15;
}
